export default "__VITE_ASSET__vzeR8fsR__"